import Resource from 'Resources/Resource';
import parseOrderStage from './parsers/orderStage';
import type OrderStage from 'App/resources/Model/OrderStage';
import { TYPE, STYLE } from 'Store/reducers/SystemNotificationReducer';

class OrderStageResource extends Resource {
	// The base is untyped .js, so the field it reads off `this` needs declaring here.
	eventName: string;

	constructor() {
		super('orderstages');

		this.eventName = 'orderStage';

		this.parse = parseOrderStage;

		// The lang keys the Angular ResourceHelper was configured with in
		// upsales/common/resources/orderStage.js, plus its own default titles. Note that create and
		// update shared a single error body there (`updateErrorBody: 'saveError.orderStage'`).
		// `opts` is optional because Resource.save calls notifications.save() with no arguments on
		// its dontWait path, outside the try/catch that guards _handleNotification.
		this.notifications = {
			save: (_data: unknown, opts?: { isNew?: boolean }) => ({
				title: opts?.isNew ? 'default.saved' : 'default.updated',
				body: opts?.isNew ? 'saved.orderStage' : 'updated.orderStage',
				style: STYLE.SUCCESS,
				icon: 'check',
				type: TYPE.BODY
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.orderStage',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			}),
			delete: () => ({
				title: 'default.deleted',
				body: 'deleted.orderStage',
				style: STYLE.SUCCESS,
				icon: 'check',
				type: TYPE.BODY
			}),
			deleteError: () => ({
				title: 'default.error',
				body: 'deleteError.orderStage',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			})
		} as any;
	}

	// The base is untyped .js, so callers would otherwise get `any` rows back — same override as
	// Script.ts. Matches the shape the deleted Tools.OrderStage declaration promised.
	find(...args: any): Promise<{ data: OrderStage[]; metadata: { total: number } }> {
		return super.find(...args);
	}
}

const resource = new OrderStageResource();

export default resource;
